module.exports = __webpack_public_path__ + "static/media/keliturbo.2476b84a.svg";